export const initialState = {
  fetch: false,
  fetchSuccess: false,
  fetchError: null,

  createMasterPdf: false,
  createMasterPdfSuccess: false,
  createMasterPdfError: null,

  collection: [],
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "MODULES_FETCH":
      return {
        ...state,
        fetch: true,
        fetchSuccess: false,
        fetchError: null,
      };

    case "MODULES_FETCH_FULFILLED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: true,

        collection: action.data.data,
      };

    case "MODULES_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: action.data,
      };

    case "MODULE_ENROLL_FULFILLED":
    case "MODULE_UNENROLL_FULFILLED":
      return {
        ...state,
        collection: state.collection.map(module => {
          if (module.id === action.data.id) {
            return action.data;
          }
          return module;
        })
      };

    case "ACTIVITY_START_FULFILLED":
    case "ACTIVITY_COMPLETE_FULFILLED":
    case "ACTIVITY_SCORE_FULFILLED":
      return {
        ...state,
        collection: state.collection.map(module => {
          return {
            ...module,
            lessons: module.lessons.map(lesson => {
              return {
                ...lesson,
                activities: lesson.activities.map(activity => {
                  return activity.id === action.data.id ? action.data : activity;
                })
              }
            })
          }
        })
      };

    case "MASTER_CERTIFICATE_PDF":
      return {
        ...state,
        createMasterPdf: true,
        createMasterPdfSuccess: false,
        createMasterPdfError: null,
      };

    case "MASTER_CERTIFICATE_PDF_FULFILLED":
      return {
        ...state,
        createMasterPdf: false,
        createMasterPdfSuccess: true,
      };

    case "MASTER_CERTIFICATE_PDF_REJECTED":
      return {
        ...state,
        createMasterPdf: false,
        createMasterPdfSuccess: false,
        createMasterPdfError: action.data,
      };

    case "CLEAR_ERRORS":
      return {
        ...initialState,
        collection: state.collection,
      };

    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
